// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__B-mar","box":"Timer_box__8OOA-"};